<template>
  <app-panel class="keyblock-microblock-panel">
    <paginated-content
      v-model:limit="pageLimit"
      pagination-style="history"
      :entities="microblocks"
      :total-count="keyblockDetails.microBlocksCount"
      @prev-clicked="loadPrevMicroblocks"
      @next-clicked="loadNextMicroblocks">
      <keyblock-microblocks-table
        :microblocks="microblocks"
        class="keyblock-microblock-panel__table"/>
    </paginated-content>
  </app-panel>
</template>

<script setup>
const { keyblockMicroblocks: microblocks, keyblockDetails } = storeToRefs(useKeyblockDetailsStore())
const { fetchKeyblockMicroblocks } = useKeyblockDetailsStore()
const route = useRoute()

const pageLimit = usePageLimit('keyblock-microblocks')

watch(pageLimit, () => {
  fetchKeyblockMicroblocks({ id: route.params.id, limit: pageLimit.value })
})

if (import.meta.client) {
  fetchKeyblockMicroblocks({
    id: route.params.id,
    limit: pageLimit.value,
  })
}

function loadPrevMicroblocks() {
  fetchKeyblockMicroblocks({ queryParameters: microblocks.value.prev })
}

function loadNextMicroblocks() {
  fetchKeyblockMicroblocks({ queryParameters: microblocks.value.next })
}
</script>

<style scoped>
.keyblock-microblock-panel__table {
  margin-bottom: var(--space-4);
}
</style>
